import React from 'react'

function Svg6(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#6_svg__clip0)" stroke="currentColor">
        <path
          d="M9 17.75v4.75l3.25-1.881L15.5 22.5v-4.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.95 2.408a2.27 2.27 0 012.6 0v0a2.27 2.27 0 001.495.401v0a2.27 2.27 0 012.252 1.3v0c.225.482.612.87 1.094 1.095v0a2.27 2.27 0 011.3 2.25v0a2.27 2.27 0 00.4 1.496v0a2.27 2.27 0 010 2.6v0a2.27 2.27 0 00-.4 1.495v0a2.27 2.27 0 01-1.3 2.252v0a2.27 2.27 0 00-1.094 1.094v0a2.27 2.27 0 01-2.252 1.3v0a2.27 2.27 0 00-1.495.4v0a2.27 2.27 0 01-2.6 0v0a2.27 2.27 0 00-1.495-.4v0a2.27 2.27 0 01-2.252-1.3v0a2.27 2.27 0 00-1.094-1.094v0a2.27 2.27 0 01-1.3-2.252v0a2.27 2.27 0 00-.4-1.495v0a2.27 2.27 0 010-2.6v0a2.27 2.27 0 00.4-1.495v0a2.27 2.27 0 011.3-2.252v0A2.27 2.27 0 007.204 4.11v0a2.27 2.27 0 012.25-1.3v0a2.27 2.27 0 001.496-.4v0z" />
        <path d="M11.373 7.597a1 1 0 011.754 0l.225.41a1 1 0 00.69.502l.46.087a1 1 0 01.542 1.668l-.32.341a1 1 0 00-.264.811l.059.465a1 1 0 01-1.419 1.03l-.424-.2a1 1 0 00-.852 0l-.424.2a1 1 0 01-1.419-1.03l.06-.465a1 1 0 00-.264-.81l-.321-.342a1 1 0 01.542-1.668l.46-.087a1 1 0 00.69-.501l.225-.411z" />
      </g>
      <defs>
        <clipPath id="6_svg__clip0">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Svg6
